export const GOOGLE = 'GOOGLE';
export const APPLE = 'APPLE';
export const OUTLOOK = 'OUTLOOK';
